import { Badge } from '@mui/joy';
import { BellSimple } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components/Button';
import { NOTIFICATION_BELL_ID, NOTIFICATION_DRAWER_ID } from 'notifications/constants';
import { useBellNotificationsContext } from 'notifications/states';
import { Color, Size, Variant } from 'theme/enums';

const BELL_ICON_SIZE = 24;
// The theme caps icon-button SVGs at 18px; the bell is drawn at the header's 24px like the design.
const BELL_BUTTON_SX = { '& svg': { width: BELL_ICON_SIZE, height: BELL_ICON_SIZE } };
const MAX_BADGE_COUNT = 99;
// Puts the badge on the icon's corner instead of the (larger) button's corner.
const BADGE_INSET = '10px';

export const NotificationBell = () => {
  const { t } = useTranslation();

  const { unreadCount, isPanelOpen, togglePanel } = useBellNotificationsContext();

  return (
    <Badge
      badgeContent={unreadCount}
      max={MAX_BADGE_COUNT}
      color={Color.DANGER}
      size={Size.SM}
      badgeInset={BADGE_INSET}
    >
      <Button
        id={NOTIFICATION_BELL_ID}
        onClick={togglePanel}
        icon={<BellSimple size={BELL_ICON_SIZE} />}
        variant={Variant.PLAIN}
        size={Size.LG}
        sx={BELL_BUTTON_SX}
        aria-label={t('labelNotifications')}
        aria-haspopup="dialog"
        aria-expanded={isPanelOpen}
        aria-controls={NOTIFICATION_DRAWER_ID}
      />
    </Badge>
  );
};
